import React from 'react'
// import { ReactComponent as LoaderSVG } from './loader.svg'
import styles from './Loading.module.css'

const Loading = props => (
  <div className={styles.base}>
    {!props.message &&
      <span className={styles.spinner} />
    }

    {props.message &&
      <div className={styles.message}>
        <span className={styles.messageText}>
          {props.message}
        </span>
      </div>
    }
  </div>
)

export default Loading
